// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Header_tabs__12k8C","logoutContainer":"Header_logoutContainer__1_jeX"};